import axios from '@api/axiosInstance.js'

export const fetchMStockMarketTrend = async () => {
  const res = await axios.post(`/chart/trends`, { count: 1 })
  return res.data
}

export const fetchMStockMarketCap = async (payload = {}) => {
  const res = await axios.post(`/rank/market-cap/top20`, payload)
  return res.data
}

export const fetchTradingSignal = async (payload = {}) => {
  const res = await axios.post('signal/trade', payload)
  return res.data
}

export const fetchKimchiPremium = async (payload = {}) => {
  const res = await axios.post('coin/premium', payload)
  return res.data
}

export const fetchEtfFlow = async (payload = {}) => {
  const res = await axios.post('coin/etf/flow', payload)
  return res.data
}

export const fetchMStockCoinAll = async (payload = {}) => {
  const res = await axios.post('/coin/all', payload)
  return res.data
}

export const fetchKdacs = async ({ assetId }) => {
  const res = await axios.post('/coin/classification', { assetId })
  return res.data
}

export const fetchCurrentCoinPrice = async ({ assetIds }) => {
  const res = await axios.post('/coin/price', { assetIds })
  return res.data
}
